// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1TgrQ","head":"Table_head__3qS9l","col":"Table_col__1lSp6"};